import { User, UserRole } from "../data/api";

export default function getProjectRoleForUserById({ user, projectId }: { user?: User; projectId?: number | string }) {
  if (!user || !projectId) return UserRole.None;
  return user.projectRoles?.find((role) => role.projectId === Number(projectId))?.role || UserRole.None;
}
